// OrganizationSystemFieldsTable.js
import React from 'react';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

const OrganizationSystemFieldsTable = ({ organization }) => {
    return (
        <Table size="small" aria-label="a dense table">
            <TableHead>
                <TableRow>
                    <TableCell align="center">Organization ID</TableCell>
                    <TableCell align="center">Organization Type</TableCell>
                    <TableCell align="center">Organization UUID</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell align="center">{organization.organizationId}</TableCell>
                    <TableCell align="center">{organization.organizationBack2BluType}</TableCell>
                    <TableCell align="center">{organization.organizationUUID}</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
};

OrganizationSystemFieldsTable.propTypes = {
    organization: PropTypes.shape({
        organizationId: PropTypes.number.isRequired,
        organizationBack2BluType: PropTypes.string.isRequired,
        organizationUUID: PropTypes.string.isRequired,
    }).isRequired,
};

export default OrganizationSystemFieldsTable;
